// extracted by mini-css-extract-plugin
export default {"container":"PreviewEmbed-module__container--k1neF"};